import {Component} from 'react';
import "./Admin/admin.css";
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
import AddAccountModal from './add_account_modal';
import ChangeAccountModal from './change_account_modal';
import AccountUpdateEmailText from './text/account_update_email_text';
import EventTrackerDeleteModal from "./event_tracker_delete_modal";
import GameInfoArchiveModal from './game_info_archive_modal';
//import SendEmail from '../../objects/CommonUse/send_email-save';
//import ConfigFile from '../../datasets/config_file';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import UpdateEventMoodPoints from './update_event_mood_points';
import OneTimeUpdate from './one_time_update';
import generateStockCSV from './objects/stock_price_generator';
import generateTBillCSV from './objects/tbill_price_generator.mjs';
import generateMortgageBondHistory from './objects/x_mortgage_price_generator';
import ExportToExcelButton from './export_to_excel';
import PlayerFeedbackDisplayModal from './player_feedback_display_modal';
import UpdatePlayerCommentModal from './update_player_comment_modal';
import ManagePlayersForAccount from '../for-parents/manage_players_for_account';

class OtherUpdates extends Component {
    constructor(props) {
        super(props);
        this.adminInfo = this.props.adminInfo();
        this.state={
          headers: setHeadersForFetch(),
          openAddAccountModal: true,
          openChangeAccountModal: true,
          accountsLoaded: false,
          buttonSelected: null,
          gamesLoaded: false,
          savingsLoaded: false,
          openOneTimeUpdate: false,
          creditCardLoaded: false,
          funStuffLoaded: false,
          timeWizardLoaded: false,
          gameInvestmentsLoaded: false,
          gamePurchasesLoaded: false,
          activityTrackerLoaded: false,
          updateTestDatasetLoaded: false,
          eventsLoaded: false,
          openMoodPointUpdate: false,
          sendEmail: false,
          openPlayerFeedbackModal: false,
          openUpdatePlayerFeedbackModal: false,
          openEventTrackerDeleteModal: false,
          openGameArchiveModal: false,
          openManagePlayers: false,
          displayFeedback: false,
          exportToExcelButton: false,
          investmentMasterLoaded: false,
          waitTimer: false,
          subProcess: "OtherUpdates",
          environment: Config.dataURL.currentEnv,
        };   
        this.accountObj = null;
        this.displayFeedbackBtnText = "Display Non-Reviewed Only";
    }

    setButtonSelected(buttonName){
        switch (buttonName){
            case "NewAccount":
                this.getAccountList();
                break;
            case "ChangeAccount":
                this.getAccountList();
                break;
            case "DeleteEventTracker":
                this.setState({openEventTrackerDeleteModal: true});
                break;
            case "ArchiveGame":
                this.loadAllGameData();
                this.setState({openGameArchiveModal: true});
                break;
            case "UpdateEventMoodPoints":
                this.loadUpdateTestDataset();
                this.eventArr = this.adminInfo.eventsData;
            //    this.loadEventsForCategory();
                this.setState({openMoodPointUpdate: true});
                break;
            case "UpdateOneTime":
                this.loadUpdateTestDataset("UpdateOneTime");
           //     this.loadAllGames();   this was for a previous update which changed jobInfo on Games-COllection
           //     this.setState({openOneTimeUpdate: true});
                break;
            case "StockPriceGenerator":
             //   this.generateMortgageBondPrices();
             //   this.generateStockPrices();
                this.generate401KPrices();
                break;
            case "GenerateInvestmentMasters":
                this.bondUpdateType = "generateMasters";
                this.loadInvestmentMasterBonds();
                break;
            case "UpdateBondRates":
                this.bondUpdateType = "updateBondRates";
                this.loadInvestmentMasterBonds();
                break;
            case "UpdateInvestMonthly":
                this.setupForInvestmentMonthlyUpdate();
                break;
            case "AddCurrentlyActive":
                this.bondUpdateType = "currentlyActive";
                this.loadInvestmentMasterBonds();
                break;
            case "UpdatePlayerComments":
                this.loadPlayerFeedback();
                break;
            case "managePlayers":
                this.buttonText = "Class/Household";
                this.accountNbr = "999999";
                this.accountOwnerArr = ["Admin"];
                this.setState({openManagePlayers: true});
                break;
            case "DeleteOldTokens":
                this.deleteOldTokens();
                break;
            default:
                break;
        }
        this.setState({sendEmail: false});
        this.setState({buttonSelected: buttonName});
    }

    generateMortgageBondPrices(){
        // use this for mortgage bonds
        let csvDataset = generateMortgageBondHistory({
            companyName: "SallyF",
            behavior: "1",
         });
        this.rptTitle = "Mortgage Bond Prices By Month";
        this.rptLines = csvDataset;
        this.setState({exportToExcelButton: true});
    }

    generateTbillPrices(){
        // use this for 6 month and 1 year Tbills
        let csvOutArr = [];
        let nbrPeriods = 30;  //  this is how many 'periods' (6-mo, 1-yr, etc) should be run 360/periodMonths
        let startMonth = 1;
        for (let i=0; i<nbrPeriods; i++){
            let csvDataset = [];
            const baseName = "TBill1YR";
            let createHeader = true;
            const min=985;
            const max=995;
           
            const startPrice = this.generateRandomRate(max, min);
            csvDataset = generateTBillCSV({
                companyName: baseName + (i+1),
                behavior: "1",
                startPrice: startPrice,
                months: 12,
                monthAdjust: startMonth + (i * 12),
                createHeader: createHeader,
            });
            csvOutArr.concat(csvDataset);
            createHeader = false;
        }
        this.rptTitle = "Tbill Prices By Month - generateTBillPrices";
        this.rptLines = csvOutArr;
        this.setState({exportToExcelButton: true});
    }

    generateStockPrices(){
        //  use this process for stocks, index funds, mutual funds and bonds (except Tbill & Mortgage)
        let csvDataset = [];
        csvDataset = generateStockCSV(
            {
                companyName: "Evergro",
                behavior: "1",
                fundType: "",
                investType: "stock",
                startPrice: 60,
                mu: 0.05,                      // Modest growth
                sigma: 0.10,                   // Low volatility
                years: 30,
                volumeMean: 600000,
                volumeVariance: 150000,
                significantDowntrend: {
                    startYear: 2030,
                    durationYears: 1,
                    driftMultiplier: -0.3,       // Mild correction
                    volatilityMultiplier: 1.2,
                    recovery: {
                    chance: 0.9,               // Very likely recovery
                    driftMultiplier: 0.4,
                    volatilityMultiplier: 1.1
                    }
                }
    }
       
    );
     
        this.rptTitle = "Investment Prices By Month";
        this.rptLines = csvDataset;
        this.setState({exportToExcelButton: true});
    }
        
    generate401KPrices(){
        //  use this process for stocks, index funds, mutual funds and bonds (except Tbill & Mortgage)
        let csvDataset = [];
        csvDataset = generateStockCSV(
            {
        companyName: "Conservative",
        behavior: "1",
        fundType: "",
        investType: "401K",
        startPrice: 75,
        mu: 0.04,                      // Modest growth
        sigma: 0.06,                   // Low volatility
        years: 30,
        volumeMean: 300000,
        volumeVariance: 150000,
    
        }
    );
        this.rptTitle = "Investment Prices By Month";
        this.rptLines = csvDataset;
        this.setState({exportToExcelButton: true});
    }

    removeExportButton(){
        this.setState({exportToExcelButton: false});
    }
   
    closeAddAccountModal(accountObj) {
        if (accountObj){
            this.setState({sendEmail: true});
            this.accountObj = accountObj;
        }else{
            this.setState({buttonSelected: ""});
        }
    }
   
    closeChangeAccountModal(accountObj) {
        if (accountObj){
            this.setState({sendEmail: true});
            this.accountObj = accountObj;
        }else{
            this.setState({buttonSelected: ""});
        }
    }

    sendEmailToAccount(){
        let textType = this.state.buttonSelected;
        if (this.state.buttonSelected === "ChangeAccount"){
            if (+this.accountObj.nbrPrimary > 0){
                textType = textType + "Primary";
            }
            if (+this.accountObj.nbrPlayers > 0){
                textType = textType + "Players";
            }
        }
        let accountMsgObj = AccountUpdateEmailText.find(elem => elem.rqstType === textType);
        let message = accountMsgObj.text;
        this.replaceTextWithVariables(this.accountObj, message);
        let userName = this.accountObj.emailAddress;
        this.emailParms={from_name: "MoneyTrain Game", to_name: userName, userName: userName,
              message: this.message, reply_to: this.accountObj.emailAddress, subject: "Account Setup"};
     //   this.pageStatus = "sendEmail";
     //   let serviceID = ConfigFile.login.accountServiceID;
     //   let publicID = ConfigFile.login.accountPublicID;
     //   let templateName = ConfigFile.login.accountTemplate;
     //   SendEmail(this.emailParms, templateName, serviceID, publicID);
        this.setState({sendEmail: false});
        this.setState({buttonSelected: ""});
    }

    replaceTextWithVariables(accountObj, message){ 
        this.message = message;
        this.message = this.message.replace("||accountNbr||", accountObj.accountNbr);
        this.message = this.message.replace("||primaryRole||", accountObj.primaryRole);
        this.message = this.message.replace("||nbrPrimary||", accountObj.nbrPrimary);
        this.message = this.message.replace("||nbrPlayers||", accountObj.nbrPlayers);
        this.message = this.message.replace("||spaces||", "        ");
    }

    buildInvestmentMaster(){
        const baseName = "Tbill1YR";
        const startMonthNbr = 1;
        const termMonths = 12;
        const term = "1";
        const termUnit = "Years";
        const max = 2.0;
        const min = 1.0;
        let nbrMasters = 30;
        const newInvestmentMaster = this.investmentMasterData.find(elem => elem.classification === "T-Bill");
        for (let j=0; j< nbrMasters; j++){
            let shortName = `${baseName}${j + 1}`; // or baseName + (j + 12)
            newInvestmentMaster.investShortName = shortName;
            newInvestmentMaster.investmentName = "12-Month Treasury Bill";
            let randomRate = this.generateRandomRate(max, min);
            randomRate = +randomRate.toFixed(4);
            let bondInfo = newInvestmentMaster.bondInfo;
            bondInfo.couponRate = randomRate.toString();
            bondInfo.term = term;
            bondInfo.termUnit = termUnit;
            bondInfo.startMonthNbr = (+startMonthNbr + (j * +termMonths)).toString();
            newInvestmentMaster.bondInfo = bondInfo;
            this.saveInvestmentMaster(newInvestmentMaster);
            nbrMasters += 1;
        }
    }

    generateRandomRate(max, min) {
        return Math.random() * (max - min) + min;
    }

    updateBondInfo(){
        const nbrUpdates = 20;
        let updateCount = 0;
        const min = .01;
        const max = .02;
        for (let i=0; i<this.investmentMasterData.length; i++){
            if (this.investmentMasterData[i].classification === "T-Bill" &&
                this.investmentMasterData[i].investShortName.includes("Tbill1YR")){
                    let bondInfo = this.investmentMasterData[i].bondInfo;
                    if (bondInfo.couponRate > max || bondInfo.couponRate < min){
                        updateCount += 1;
                        const randomRate=this.generateRandomRate(min, max);
                        bondInfo.couponRate = randomRate.toFixed(4);
                        const bodyObj = {investShortName: this.investmentMasterData[i].investShortName,
                            bondInfo: bondInfo}
                        this.updateInvestmentMaster(bodyObj); 
                        if (updateCount > nbrUpdates){
                            alert ("updates to bondinfo completed: " + updateCount);
                            break;
                        }
                    }
            }
             
        }
        if (updateCount === 0){
            alert ("no master records found with invalid bond coupon rates.")
        }
    }

    setupForInvestmentMonthlyUpdate(){
         let oldBaseName = "Tbill1YR";
         let newBaseName = "Tbill1YR";
         const nbrUpdates = 10;
         const startNbr = 22;
         for (let i=0; i<nbrUpdates; i++){
            this.shortName = oldBaseName + (startNbr + i);
            this.beginMonth = 0;
            this.endMonth = 999;
            const shortName = newBaseName + (startNbr + i);
   //         const investmentMonthlyObj = {investShortName: shortName}
   //         this.updateInvestmentMonthly(investmentMonthlyObj);
            const investmentMasterObj = {investShortName: shortName, investmentName: "Treasury Bill - 1 Year"}
            this.updateInvestmentMasterNames(investmentMasterObj);
         }
    }
    
    updateCurrentlyActive(){
        const nbrUpdates = 30;
        let updateCount = 0;
      
        for (let i=0; i<this.investmentMasterData.length; i++){
            if (!this.investmentMasterData[i].currentlyActive){
                updateCount += 1;
                const bodyObj = {investShortName: this.investmentMasterData[i].investShortName }
                this.updateInvestmentMaster(bodyObj); 
                if (updateCount > nbrUpdates){
                    console.log("shortName: ", this.investmentMasterData[i].investShortName);
                    alert ("updates to currently active completed: " + updateCount);
                    break;
                }
            }
        }
        if (updateCount === 0){
            alert ("no master records found with missing currentlyActive switch.")
        }
    }

    closeModals(modalName){
        switch (modalName){
            case "EventTracker":
                this.setState({openEventTrackerDeleteModal: false});
                break;
            case "ArchiveGame":
                this.allGameDataLoaded = false;
                this.setState({openGameArchiveModal: false});
                break;
            case "UpdateEventMoodPoints":
                this.setState({openMoodPointUpdate: false});
                break;
            case "UpdateOneTime":
                this.setState({openOneTimeUpdate: false});
                break;
            case "playerFeedback":
                this.setState({openPlayerFeedbackModal: false});
                break;
            case "updatePlayerFeedback":
                this.setState({openUpdatePlayerFeedbackModal: false});
                break;
            case "managePlayers":
                this.setState({openManagePlayers: false});
                break;
            default:
                break;
        }
    }

    filterByReviewCode(reviewCode){
        this.filterPlayerFeedback = JSON.parse(JSON.stringify(this.playerFeedback));
        if (reviewCode === "all"){
            //  no filter is applied - select all
        }else{
            if (reviewCode === "99"){
                this.filterPlayerFeedback = this.playerFeedback.filter(elem => elem.reviewed === undefined);
            }else{
                this.filterPlayerFeedback = this.playerFeedback.filter(elem => elem.reviewed.code === reviewCode)
            }
        }
        this.setState({displayFeedback: !this.state.displayFeedback});
    }

    updatePlayerFeedback(selectedComment){
        this.closeModals("playerFeedback");
        this.selectedComment = selectedComment;
        this.setState({openUpdatePlayerFeedbackModal: true});
    }

    closeUpdateOpenPlayerFeedback(updatedReviewComment){
        if (updatedReviewComment && updatedReviewComment._id){
            const updtIndx = this.playerFeedback.findIndex(elem => elem._id === updatedReviewComment._id);
            if (updtIndx !== -1){
                this.playerFeedback[updtIndx] = updatedReviewComment;
            } 
        }
        this.closeModals("updatePlayerFeedback");
        this.setState({openPlayerFeedbackModal: true});
    }

    async processJobSkillsArr(){
        for (let i=0; i<this.updateTestDataset.length; i++){
            let update = this.updateTestDataset[i];
            let skillsArr = [];
            skillsArr.push(update.Technology);
            skillsArr.push(update.Detail);
            skillsArr.push(update.Dexterity);
            skillsArr.push(update.Empathy);
            skillsArr.push(update.Interpersonal);
            skillsArr.push(update.Math);
            skillsArr.push(update.Multitasking);
            skillsArr.push(update.Organization);
            skillsArr.push(update.Physical);
            skillsArr.push(update.ProblemSolving);
            skillsArr.push(update.VerbalCommunication);
            skillsArr.push(update.WrittenCommunication)
            const updateObj = {jobID: update.jobID, jobName: update.jobName, skillsArr: skillsArr};
            await this.updateJobInfo(updateObj);
        }
    }
                 
    render() {
        if (this.state.gamesLoaded === true && this.state.savingsLoaded === true &&
              this.state.creditCardLoaded === true && this.state.funStuffLoaded === true &&
              this.state.activityTrackerLoaded === true && this.state.timeWizardLoaded === true &&
              this.state.gameInvestmentsLoaded === true && this.state.gamePurchasesLoaded === true ){
              this.allGameDataLoaded = true;
        }
        if (this.state.investmentMasterLoaded === true){
            if (this.bondUpdateType === "generateMasters"){
                this.buildInvestmentMaster();
            }else{
                if (this.bondUpdateType === "updateBondRates"){
                     this.updateBondInfo();
                }else{
                     this.updateCurrentlyActive();
                }
            }
        }
     
        
    return <>
    
        <div className="col-sm-6 mb-5 input-page-base-card">
            <div className="card mt-3 mr-5 rounded-corners-lg height-max">
                <h1 className="mt-2 p-0 text-center">Game Administration</h1>
                <h4 className="text-center">Other Admin Updates for MoneyTrain Game</h4>
                <table className="row-100 ml-2 mt-3 overflow-scroll">
                    <tbody >
                        <tr>
                            <td className = "col-sm-6 ">  
                                <div className="mt-2">
                                    <button className="btn-group-wide" 
                                         onClick ={()=> this.setButtonSelected("NewAccount")}>
                                            Add New Account
                                    </button>
                                </div>
                            </td>
                            <td className="col-sm-6 ">
                                 <div className="mt-2">
                                    <button className=" btn-group-wide" 
                                        onClick ={()=> this.setButtonSelected("ChangeAccount")}>
                                            Change Account Information
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="col-sm-6 ">
                                 <div className="mt-2">
                                    <button className=" btn-group-wide" 
                                        onClick ={()=> this.setButtonSelected("DeleteEventTracker")}>
                                            Delete Event Tracker Information
                                    </button>
                                </div>
                            </td>
                            <td className="col-sm-6 ">
                                 <div className="mt-2">
                                    <button className=" btn-group-wide" 
                                        onClick ={()=> this.setButtonSelected("ArchiveGame")}>
                                            Archive Old Games and Orphaned Records
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr className="mt-2">
                            <td className="col-sm-6 ">
                                <div className="mt-2">
                                    <button className=" btn-group-wide" 
                                        onClick ={()=> this.setButtonSelected("UpdateEventMoodPoints")}>
                                            Update Event Mood Points
                                </button>
                                </div>
                            </td>
                            <td className="col-sm-6 ">
                                 <div className="mt-2">
                                    <button className=" btn-group-wide" 
                                        onClick ={()=> this.setButtonSelected("UpdateOneTime")}>
                                            One Time Update - Fix JobInfo
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr className="mt-2">
                          <td className="col-sm-6 ">
                                <div className="mt-2">
                                    <button className=" btn-group-wide" 
                                        onClick ={()=> this.setButtonSelected("StockPriceGenerator")}>
                                        Create Investment Price Data
                                    </button>
                                </div>
                            </td>
                             <td className="col-sm-6 ">
                                 <div className="mt-2">
                                    <button className=" btn-group-wide" 
                                        onClick ={()=> this.setButtonSelected("GenerateInvestmentMasterX")}>
                                            Create Investment Master
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr className="mt-2">
                          <td className="col-sm-6 ">
                                <div className="mt-2">
                                    <button className=" btn-group-wide" 
                                        onClick ={()=> this.setButtonSelected("UpdateBondRatesX")}>
                                        Update Bond Rates
                                    </button>
                                </div>
                            </td>
                             <td className="col-sm-6 ">
                                <div className="mt-2">
                                    <button className=" btn-group-wide" 
                                        onClick ={()=> this.setButtonSelected("UpdateInvestMonthlyX")}>
                                        Update Bond Names
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr className="mt-2">
                          <td className="col-sm-6 ">
                                <div className="mt-2">
                                    <button className=" btn-group-wide" 
                                        onClick ={()=> this.setButtonSelected("AddCurrentlyActiveX")}>
                                        Add CurrentlyActive to Masters
                                    </button>
                                </div>
                            </td>
                            <td className="col-sm-6">
                                 <div className="mt-2">
                                    <button className=" btn-group-wide" 
                                        onClick ={()=> this.setButtonSelected("UpdatePlayerComments")}>
                                        Update Player Comments
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr className="mt-2">
                          <td className="col-sm-6 ">
                                <div className="mt-2">
                                    <button className=" btn-group-wide" 
                                        onClick ={()=> this.setButtonSelected("managePlayers")}>
                                        Add/Change Account Players
                                    </button>
                                </div>
                            </td>
                            <td className="col-sm-6">
                                 <div className="mt-2">
                                    <button className=" btn-group-wide" 
                                        onClick ={()=> this.setButtonSelected("DeleteOldTokens")}>
                                        Delete Old User Tokens
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                {this.state.waitTimer  ?
                    <WaitTimeSpinner/>
                :
                    null
                }

                    {!this.state.sendEmail ?
                        <span className="mt-4">
                        {this.state.buttonSelected === "NewAccount" && this.state.accountsLoaded ?
                            <AddAccountModal openModal={this.state.openAddAccountModal} 
                                accountList={this.accountInfo}
                                onClose={(accountObj) => this.closeAddAccountModal(accountObj)}
                                processError = {(errorObj) =>  this.props.processError(errorObj)}
                            />
                        :
                            null
                        }

                        {this.state.buttonSelected === "ChangeAccount" && this.state.accountsLoaded ?
                            <ChangeAccountModal openModal={this.state.openChangeAccountModal} 
                                accountList={this.accountInfo}
                                onClose={(accountObj) => this.closeChangeAccountModal(accountObj)} 
                            />
                        :
                            null
                        }

                        {this.state.buttonSelected === "DeleteEventTracker"  ?
                            <EventTrackerDeleteModal openModal={this.state.openEventTrackerDeleteModal} 
                                onClose={() => this.closeModals("EventTracker")} 
                            />
                        :
                            null
                        }
                  
                        {this.state.buttonSelected === "ArchiveGame" ?
                            <span>
                            {this.allGameDataLoaded  ?
                                <GameInfoArchiveModal openModal={this.state.openGameArchiveModal} 
                                    gameInfoArr={this.gameInfoArr}
                                    savingsArr={this.savingsArr}
                                    creditCardArr={this.creditCardArr}
                                    funStuffArr={this.funStuffArr}
                                    activityTrackerArr={this.activityTrackerArr}
                                    timeWizardArr={this.timeWizardArr}
                                    gameInvestmentsArr={this.gameInvestmentsArr}
                                    gamePurchasesArr={this.gamePurchasesArr}
                                    onClose={() => this.closeModals("ArchiveGame")} 
                                    processError = {(errorObj) =>  this.props.processError(errorObj)}
                                />
                            :
                                <span>
                                    <div className="text-center mt-3">
                                        <button className="btn btn-primary w-50 mt-6" 
                                            disabled={true}>
                                                Archive Old Games and Orphaned Records
                                        </button>
                                    </div>
                                    <div className="text-center mt-3">
                                        <WaitTimeSpinner/>
                                    </div>
                                </span>
                            }
                            </span>
                        :
                            null
                        }
                        </span>

                    :
                            <div className="text-center mt-5">
                                <button className="btn btn-primary w-50 mt-6" 
                                    onClick ={()=> this.sendEmailToAccount()}>
                                         Send Email to Account Owner
                                </button>
                            </div>
                    }
                    {this.state.updateTestDatasetLoaded &&
                        this.state.openMoodPointUpdate ?
                        <UpdateEventMoodPoints
                            openModal={this.state.openMoodPointUpdate}
                            updateDataset = {this.updateTestDataset}
                            eventList = {this.eventArr}
                            onClose={() => this.closeModals("UpdateEventMoodPoints")} 
                            processError = {(errorObj) =>  this.props.processError(errorObj)}
                        />
                    :
                        null    
                    }

                    {this.state.buttonSelected === "UpdateOneTime"  && this.state.gamesLoaded ?
                        <OneTimeUpdate
                            openModal={this.state.openOneTimeUpdate}
                            gameData={this.gameInfoArr}
                            onClose={() => this.closeModals("UpdateOneTime")} 
                        />
                    :
                        null
                    }

                     {this.state.openPlayerFeedbackModal ?
                        <PlayerFeedbackDisplayModal openModal={this.state.openPlayerFeedbackModal} 
                            commentsOnly={true}
                            updateFeedback={true}
                            onClose={() => this.closeModals("playerFeedback")} 
                            playerFeedback={this.filterPlayerFeedback}
                            displayFeedbackBtnText={this.displayFeedbackBtnText}
                            filterByReviewCode={(reviewCode) => this.filterByReviewCode(reviewCode)}
                            updatePlayerFeedback={(obj) => this.updatePlayerFeedback(obj)}
                        />
                    :
                       null
                    }

                     {this.state.openUpdatePlayerFeedbackModal ?
                        <UpdatePlayerCommentModal
                            openModal={this.state.openUpdatePlayerFeedbackModal}
                            commentInfo={this.selectedComment}
                            onClose={(updatedComment) => this.closeUpdateOpenPlayerFeedback(updatedComment)}
                            processError = {(errorObj) =>  this.props.processError(errorObj)}
                        />
                    :
                        null
                    }
                    
                    {this.state.openManagePlayers ?
                        <ManagePlayersForAccount 
                            show={this.state.openManagePlayers}
                            accountType={this.buttonText}
                            accountNbr={this.accountNbr}
                            accountOwnerArr={this.accountOwnerArr}
                            onClose={() => this.closeModals("managePlayers")}
                            updateUser={(userObj) => this.updateUser(userObj)}
                            processError={(errorObj) => this.props.processError(errorObj)}
                        />
                    :
                        null
                    }
    
                    {this.state.exportToExcelButton ?
                       <div className="text-center mb-5">
                        <ExportToExcelButton
                            fileName={this.rptTitle}
                            rptHeader={this.rptHeader}
                            data={this.rptLines}
                            exportComplete={() => this.removeExportButton()}
                        />
                        </div>
                    :
                        null
                    }
                   </div>
                </div>        
                   
        </>
    }

componentDidMount(){
    this._isMounted = true;
}

getAccountList(){
    const funcName = "loadAccountList";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {method:'GET',
         headers: this.state.headers,
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.accountInfo = output.body;
                        this.setState({accountsLoaded: true});
                        alert("Account List has been loaded!!");
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
        })
  }

  loadAllGameData(){
    this.allGameDataLoaded = false;
    this.loadAllGames();
    this.loadAllCreditCardInfo();
    this.loadAllFunStuff();
    this.loadAllSavings();
    this.loadAllActivityTracker();
    this.loadAllTimeWizard();
    this.loadAllGameInvestments();
    this.loadAllGamePurchases();
}

  loadAllGames(){
    const funcName = "loadAllGames";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {method:'GET',
         headers: this.state.headers,
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.gameInfoArr = output.body;
                        this.setState({gamesLoaded: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
        })
  }
  
  loadAllCreditCardInfo(){
    const funcName = "loadAllCreditCard";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {method:'GET',
         headers: this.state.headers,
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.creditCardArr = output.body;
                        this.setState({creditCardLoaded: true});
                    }else{
                        if (statusCode === 250){
                            this.creditCardArr = [];
                            this.setState({creditCardLoaded: true});
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.props.processError(errorObj);
                        }
                    }
                });
            };
        })
  }

  
  loadAllFunStuff(){
    const funcName = "loadAllFunStuff";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {method:'GET',
         headers: this.state.headers,
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.funStuffArr = output.body;
                        this.setState({funStuffLoaded: true});
                    }else{
                        if (statusCode === 250){
                            this.funStuffArr = [];
                            this.setState({funStuffLoaded: true})
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.props.processError(errorObj);
                        }
                    }
                });
            };
        })
  }
  
  loadAllSavings(){
    const funcName = "loadAllSavings";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {method:'GET',
         headers: this.state.headers,
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.savingsArr = output.body;
                        this.setState({savingsLoaded: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
        })
  }
  
  loadAllActivityTracker(){
    const funcName = "loadAllActivityTrackers";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {method:'GET',
         headers: this.state.headers,
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.activityTrackerArr = output.body;
                        this.setState({activityTrackerLoaded: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
        })
  }

  loadAllTimeWizard() {
    const funcName = "loadAllTimeWizard";
    const urlParm = ""; 
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
   
    {method:'GET', headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.timeWizardArr = output.body;
                    this.setState({timeWizardLoaded: true});
                }else{
                    if (statusCode === 250){
                       this.timeWizardArr = [];
                       this.setState({timeWizardLoaded: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                }
            });
        };
    });
}

loadAllGameInvestments(){
     const funcName = "loadAllGameInvestments";
    const urlParm = ""; 
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
   
    {method:'GET', headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.gameInvestmentsArr = output.body;
                    this.setState({gameInvestmentsLoaded: true});
                }else{
                    if (statusCode === 250){
                       this.gameInvestmentsArr = [];
                       this.setState({gameInvestmentsLoaded: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                }
            });
        };
    });
}


loadAllGamePurchases(){
    const funcName = "loadAllGamePurchases";
    const urlParm = ""; 
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
   
    {method:'GET', headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.gamePurchasesArr = output.body;
                    this.setState({gamePurchasesLoaded: true});
                }else{
                    if (statusCode === 250){
                       this.gamePurchasesArr = [];
                       this.setState({gamePurchasesLoaded: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                }
            });
        };
    });
}

 saveContactUs() {
    let headers = {'Content-Type': 'application/json',
        'Authorization': {},
    };
    if (this.emailParms.userName !==  "NotSignedIn"){
        headers = this.state.headers;
    }
    let dateObj = getCurrentDateTime();
    let bodyObj = {
        fromName: this.emailParms.from_name,
        toName: this.emailParms.to_name,
        userName: this.emailParms.userName,
        subject: this.emailParms.subject,
        message: this.emailParms.message,
        replyTo: this.emailParms.reply_to,
        dateAdded: dateObj.date,
        timeAdded: dateObj.time
    };
    const funcName = "saveContactUsEmail";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {
        method:'POST',
        headers: headers,
        body: JSON.stringify(bodyObj)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        alert("Update of contactUsEmail failed. Page will automatically refresh once you click OK.");
                        window.location.reload(false);
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: bodyObj };
                        this.props.processError(errorObj);
                    }
                });
            };
        });
}

loadUpdateTestDataset(buttonSelected){
    const funcName = "loadUpdateTestDataset";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {method:'GET',
         headers: this.state.headers,
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.updateTestDataset = output.body;
                        if (buttonSelected === "UpdateOneTime"){
                            this.processJobSkillsArr();
                        }
                        this.setState({updateTestDatasetLoaded: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
        })
  }
  
loadEventsForCategory(){
    const gamePhase = "GetAllPhases";
    const category = "job";
    const jobName = "allJobEvents";
    const funcName = "loadEvents";
    const urlParm = "?gamePhase=" + gamePhase + "&eventCategory=" + category +
        "&jobName=" + jobName;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
          {method:'GET', headers: this.state.headers})
          .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.eventArr = JSON.parse(JSON.stringify(output.body));
                        this.setState({eventsLoaded: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
      });
}

 loadInvestmentMasterBonds(){
     const funcName = "investmentMasterList";
     const urlParm = "?queryType=investType&investType=bond";
     const uri = buildUrl(this.state.environment, funcName, urlParm);
     fetch (uri,  
             {method:'GET', headers: this.state.headers})
     .then(response => {
         if (response.ok){
             response.json().then(data => {
                 const output = JSON.parse(data);
                 const statusCode = output.statusCode;
                 if (statusCode === 200){
                     this.investmentMasterData = output.body;
                     if (this._isMounted === true){
                         this.setState({investmentMasterLoaded: true});
                     }
                 }else{
                     const errorObj={function: funcName, subProcess: this.state.subProcess, 
                             status: statusCode, message: output.body.message, errorObject: urlParm};
                     this.props.processError(errorObj);
                 }
             });
         };
     });
 }
 
loadPlayerFeedback(){
    const funcName = "loadPlayerFeedback";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
       {method:'GET', headers: this.state.headers})
       .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.sortPlayerFeedback(output.body);
                    this.setState({openPlayerFeedbackModal: true});
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    });
}

sortPlayerFeedback(playerFeedback){
    this.playerFeedback = [];
    for (let i=0; i<playerFeedback.length; i++){
        let feedback = playerFeedback[i];
        if (feedback.reviewed && feedback.reviewed.reviewStatus && 
            feedback.reviewed.reviewStatus === "archive"){
            // skip these will be archived
        }else{
            let sortKey = playerFeedback[i].user + playerFeedback[i].dateAdded + playerFeedback[i].timeAdded;
            let feedbackObj = {...playerFeedback[i], sortKey: sortKey};
            this.playerFeedback.push(feedbackObj);
        }
    }
    (this.playerFeedback).sort((a, b) => (a.sortKey > b.sortKey) ? 1 : -1)
    this.filterPlayerFeedback = JSON.parse(JSON.stringify(this.playerFeedback));
}
 
 saveInvestmentMaster(investmentMaster){
     const funcName = "saveInvestmentMaster";
     const urlParm = "";
     const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {
        method:'POST',
        headers: this.state.headers,
        body: JSON.stringify(investmentMaster)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
              //             "Save of Investment Master successul.";
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: investmentMaster };
                        this.props.processError(errorObj);
                    }
                });
            };
        });
 }

  updateInvestmentMaster(bodyObj){
     const funcName = "updateInvestmentMaster";
     const urlParm = "";
     const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {
        method:'PUT',
        headers: this.state.headers,
        body: JSON.stringify(bodyObj)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
              //             "Update of Investment Master successful.";
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: bodyObj };
                        this.props.processError(errorObj);
                    }
                });
            };
        });
 }
 
 updateInvestmentMasterNames(bodyObj){
     const funcName = "updateInvestmentMasterNames";
     const urlParm = "?investShortName=" + this.shortName;
     const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {
        method:'PUT',
        headers: this.state.headers,
        body: JSON.stringify(bodyObj)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        alert ("update of investment master successful")
              //             "Update of Investment Master successful.";
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: bodyObj };
                        this.props.processError(errorObj);
                    }
                });
            };
        });
 }
 
updateInvestmentMonthly(bodyObj){
     const funcName = "updateInvestmentMonthly";
     this.gameInvestBehavior = "1";
     //const shortNameList = this.shortNameArr.join(',');
     const urlParm = "?investShortName=" + this.shortName + "&behavior=" + this.gameInvestBehavior  + 
         "&startMonthNbr=" + this.beginMonth +  "&endMonthNbr=" + this.endMonth;
     const uri = buildUrl(this.state.environment, funcName, urlParm);
     fetch (uri,  
        {
            method:'PUT',
            headers: this.state.headers,
            body: JSON.stringify(bodyObj)
        })
     .then(response => {
         if (response.ok){
             response.json().then(data => {
                 const output = JSON.parse(data);
                 const statusCode = output.statusCode;
                 if (statusCode === 200){
                     // update of Investment Monthly successful 
                 }else{
                     const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                 status: statusCode, message: output.body.message, errorObject: urlParm};
                     this.props.processError(errorObj);
                 }
             });
         };
     });
 }

 
updateUser(userObj){
    const funcName = "updateUserAccount";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);

    fetch(uri,
        {
            method: 'PUT', 
            headers: this.state.headers,
            body: JSON.stringify(userObj)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (output.statusCode === 200){ 
                    alert ("Update was successful");
                    const userInfo = output.body;
                    sessionStorage.setItem('defaultUserAccount', userInfo.accountNbr);
                    this.closeModals("managePlayers");
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, errorObject: this.creditCardObj};
                    this.props.processError(errorObj);
                }
            });
            }
        });
    }

    deleteOldTokens(){
        this.setState({waitTimer: true});
        const dateTimeObj = getCurrentDateTime()
        const dateArr = dateTimeObj.date.split("/");
        const deleteYear = +dateArr[0] - 1;
        const deleteDate = deleteYear + "/" + dateArr[1] + "/" + dateArr[2];
        const funcName = "deleteOldTokens";
        const urlParm = "?deleteDate=" + deleteDate;
        const uri = buildUrl(this.state.environment, funcName, urlParm);

        fetch(uri,
            {
                method: 'DELETE', 
                headers: this.state.headers
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (output.statusCode === 200){ 
                        alert ("Delete of tokens was successful. " +
                            " Number deleted was: " + output.body.count
                        );
                        this.setState({waitTimer: false});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.creditCardObj};
                        this.props.processError(errorObj);
                    }
                });
                }
            });
    }

async updateJobInfo(bodyObj){
    const funcName = "updateJobInfo";
    //const shortNameList = this.shortNameArr.join(',');
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);

    const response = await fetch(uri, {
        method: 'PUT',
        headers: this.state.headers,
        body: JSON.stringify(bodyObj)
    });

    if (response.ok){
        const data = await response.json();
        const output = JSON.parse(data);
        const statusCode = output.statusCode;
        if (statusCode === 200){
            // update of Job Info successful
        } else {
            const errorObj = {
                function: funcName,
                subProcess: this.state.subProcess,
                status: statusCode,
                message: output.body.message,
                errorObject: urlParm
            };
            this.props.processError(errorObj);
        }
    }
}

}

export default OtherUpdates;